// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { FieldsFactory } from "../Factory/FieldsFactory.js"
import { MessageProcessorBase } from "./MessageProcessorBase.ts"
import { DirectReportTypeMessage } from "../../../../Utils/DirectMessages/DirectReportTypeMessage.js"
export let ReportTypeMessageProcessor = function ()
{
    MessageProcessorBase.call(this)
}

ReportTypeMessageProcessor.prototype = Object.create(MessageProcessorBase.prototype)

ReportTypeMessageProcessor.prototype.decode = function (fieldSet)
{
    let factory = FieldsFactory
    let msg = new DirectReportTypeMessage()

    msg.name = fieldSet.GetValue(factory.FIELD_NAME)
    msg.id = fieldSet.GetValue(factory.FIELD_ID)
    msg.accessType = fieldSet.GetValue(factory.FIELD_TYPE)

    let groups = fieldSet.GetGroups(factory.REPORT_PARAM_GROUP)
    let len = groups.length
    for (let i = 0; i < len; i++)
    {
        let group = groups[i]

        let parameter = {
            name: group.GetValue(factory.FIELD_NAME),
            type: group.GetValue(factory.FIELD_TYPE),
            params: group.GetValue(factory.FIELD_PARAMS)
        }

        msg.parameters.push(parameter)
    }

    return [msg]
}
